module.exports = __webpack_public_path__ + "static/media/img136.b0ab02bd.jpg";